import { jsx as _jsx } from "react/jsx-runtime";
import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { useSelector } from 'react-redux';
import { isInACQ140VariantBCRM } from '../experiments/gswhV1/gswhUtils';

const CompanySizeView = () => {
  const options = DataOptions[Data.CompanySize];
  const isAssignedToACQ140VariantBCrm = useSelector(isInACQ140VariantBCRM);
  const helperText = isAssignedToACQ140VariantBCrm ? 'views.COMPANY_SIZE.subtitle.acq140.variant_b_crm' : '';
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    helperTextString: helperText,
    options: options,
    shouldDisableAutofocus: true,
    shouldShowHelperText: isAssignedToACQ140VariantBCrm
  });
};

export default CompanySizeView;